import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { change } from 'redux-form';
import { injectIntl } from 'react-intl';
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import CommonModal from '../Modal/CommonModal';
import { getLatestBookingStatus } from '../../helpers/getLatestBooking';
import { getBooking } from '../../actions/booking/getBooking';
import { getLocationsBasedOnStatus } from '../../helpers/getLocationBasedOnStatus';
import { getMapRouteDirections } from '../../actions/booking/getMapRouteDirections';
import { openHeaderModal, closeHeaderModal } from '../../actions/siteadmin/modalActions';
import history from '../../history';
import messages from '../../locale/messages';
import getAllCancelReasons from './getAllCancelReasons.graphql'
import inprogress from "../../../public/Icons/inprogress.svg"
import completed from '../../../public/Icons/completed.svg';
import useQueryResponse from '../../lib/hooks/useQueryResponse';
import CancelReasonForm from '../CancelReasonForm/CancelReasonForm';
import BookingIdCard from '../BookingIdCard/BookingIdCard';
import bt from '../../components/commonStyle.css';
import s from './OrderStatus.css';



function OrderStatus({ data, socket, id, isTopRadius, intl: { formatMessage } }) {

    const dispatch = useDispatch()

    const cancelReasonForm = useSelector(state => state?.adminModalStatus?.cancelReasonForm)

    const { data: cancelReasonData, loading } = useQueryResponse({
        query: getAllCancelReasons,
        variables: {
            userType: 1
        },
        ssr: false,
        fetchPolicy: 'network-only'
    })

    useEffect(() => {
        async function fetchData() {
            let distanceType, pickUpLocation, dropLocation;
            const locations = await getLocationsBasedOnStatus(data);

            pickUpLocation = locations?.pickUpLocation;
            dropLocation = locations?.dropLocation;
            distanceType = 'km';
            setTimeout(async () => {
                await dispatch(getMapRouteDirections({ distanceType, pickUpLocation, dropLocation }));
            }, 1000);
        }
        fetchData()

    }, [])

    // Refetch the booking when the worker finishes the job so the page flips to the final bill /
    // payment screen. Register on [socket, data?.id] (NOT []) — data loads async, and a [] effect that
    // ran before data?.id was set would never attach the listener (so the bill never opened). Listen to
    // BOTH bookingStatusUpdated- and serviceCompleted- (the api emits both on completion). off()+on()
    // keeps it idempotent across re-renders / socket reconnects.
    useEffect(() => {
        if (!socket || !data?.id) return undefined;
        const refetch = async () => { await dispatch(getBooking(id || data?.id)); };
        socket.off(`bookingStatusUpdated-${data?.id}`);
        socket.on(`bookingStatusUpdated-${data?.id}`, refetch);
        socket.off(`serviceCompleted-${data?.id}`);
        socket.on(`serviceCompleted-${data?.id}`, refetch);
        return () => {
            socket.off(`bookingStatusUpdated-${data?.id}`, refetch);
            socket.off(`serviceCompleted-${data?.id}`, refetch);
        };
    }, [socket, data?.id])


    let status1 = inprogress, status2 = inprogress, status3 = inprogress, status4 = inprogress, status6 = inprogress, status7 = inprogress;
    let progress1 = 0, progress2 = 0, progress3 = 0, progress4 = 0, progress5 = 0, progress6 = 0;
    let content1, content2, content3, content4, content5, content6;
    let partnerName = data?.partnerDetails?.firstName;

    const isBookingStarted = data?.status === 'started';

    let latestBookingStatus = getLatestBookingStatus(data?.bookingHistory);

    const isBookingAvailable = ['cancelledByPartner', 'declined'].includes(data?.status);
    isBookingAvailable && window.location.replace('/dashboard');

    if (data?.bookingHistory?.length > 0) {
        data?.bookingHistory?.map((item, index) => {
            if (item.status === 'created') {
                status1 = completed;
                content1 = (latestBookingStatus?.status === 'created') ? (
                    <>
                        <span>{`${formatMessage(messages.requestCreatedContent)}`} &nbsp;</span>
                        <span className={s.orderStatusCancelBookingContainer}>
                            <a href={'#'} onClick={(e) => {
                                e.preventDefault();
                                dispatch(openHeaderModal('cancelReasonForm'));
                            }} className={bt.viewAllLink}>
                                <FormattedMessage {...messages.cancelBooking} />
                            </a>
                        </span>
                    </>
                ) : `${formatMessage(messages.requestCreatedContent)}`;
            }
            if (item.status === 'approved') {
                status2 = completed;
                progress1 = 1;
                content2 = (latestBookingStatus?.status === 'approved') ? (
                    <>
                        <span>{`${partnerName} ${formatMessage(messages.requestAcceptedContent)}`} &nbsp;</span>
                        <span className={s.orderStatusCancelBookingContainer}>
                            <a href={'#'} onClick={(e) => {
                                e.preventDefault();
                                dispatch(openHeaderModal('cancelReasonForm'));
                            }} className={bt.viewAllLink}>
                                <FormattedMessage {...messages.cancelBooking} />
                            </a>
                        </span>
                    </>
                ) : `${partnerName} ${formatMessage(messages.requestAcceptedContent)}`;
            }
            if (item.status === 'arrived') {
                status3 = completed;
                progress2 = 1;
                content3 = (latestBookingStatus?.status === 'arrived') ? (
                    <>
                        <span>{`${partnerName} ${formatMessage(messages.requestArrivedContent)}`} &nbsp;</span>
                        <span className={s.orderStatusCancelBookingContainer}>
                            <a href={'#'} onClick={(e) => {
                                e.preventDefault();
                                dispatch(openHeaderModal('cancelReasonForm'));
                            }} className={bt.viewAllLink}>
                                <FormattedMessage {...messages.cancelBooking} />
                            </a>
                        </span>
                    </>
                ) : `${partnerName} ${formatMessage(messages.requestArrivedContent)}`;
            }
            if (item.status === 'reviewed') {
                status4 = completed;
                progress3 = 1;
                content4 = (latestBookingStatus?.status === 'reviewed') ? (
                    <>
                        <span>{`${partnerName} ${formatMessage(messages.requestReviewedContent)}`} &nbsp;</span>
                        <span className={s.orderStatusCancelBookingContainer}>
                            <a href={'#'} onClick={(e) => {
                                e.preventDefault();
                                dispatch(openHeaderModal('cancelReasonForm'));
                            }} className={bt.viewAllLink}>
                                <FormattedMessage {...messages.cancelBooking} />
                            </a>
                        </span>
                    </>
                ) : `${partnerName} ${formatMessage(messages.requestReviewedContent)}`;
            }
            if (item.status === 'started') {
                status6 = completed;
                progress4 = 1;
                content5 = `${partnerName} ${formatMessage(messages.requestStartedContent)}`;
            }
            if (item.status === 'completed') {
                status7 = completed;
                progress5 = 1;
                content6 = `${formatMessage(messages.requestCompletedContent)} ${partnerName}`;
            }
        })
    }

    const closeCancelReasonModal = () => {
        dispatch(change('CancelReasonForm', 'reason', null));
        dispatch(change('CancelReasonForm', 'otherReason', null));
        dispatch(closeHeaderModal('cancelReasonForm'));
    }

    return (
        <>
            <CommonModal
                title={formatMessage(messages.cancelReason)}
                onHide={closeCancelReasonModal}
                modalStatus={cancelReasonForm}>
                <CancelReasonForm bookingId={id} cancelReason={cancelReasonData} cancelLoading={loading} />
            </CommonModal>
            <div className={bt.space1}>
                <BookingIdCard id={id} isBookingPage={true} status={data?.status} isTopRadius={true} />
            </div>
            <div className={cx(bt.commonViewBookingRsBox, isTopRadius ? s.orderStatusBoxTopRadius : s.orderStatusBoxBottomRadius)}>
                <h5 className={cx(bt.commonViewBookingHeading, bt.space2)}><FormattedMessage {...messages.orderStatusLabel} /></h5>
                <div>
                    {data?.bookingType === 1 && <div className={cx(s.orderStatusTrackBox, 'orderStatusTrackBoxRtl', { [s.completedStatus]: progress1 })}>
                        <div className={s.orderStatusTrackImgContainer}><img src={status1} alt="" className={s.orderStatusTrackImg} /></div>
                        <div className={bt.textAlignStart}>
                            <div className={cx(bt.commonSize16, bt.primaryColor, bt.fontWeight600)}><FormattedMessage {...messages.requestCreated} /></div>
                            <div className={cx(bt.commonSize14, bt.secondaryColor, s.orderStatusContent)}>{content1}</div>
                        </div>
                    </div>}
                    <div className={cx(s.orderStatusTrackBox, 'orderStatusTrackBoxRtl', { [s.completedStatus]: progress2 })}>
                        <div className={s.orderStatusTrackImgContainer}><img src={status2} alt="" className={s.orderStatusTrackImg} /></div>
                        <div className={bt.textAlignStart}>
                            <div className={cx(bt.commonSize16, bt.primaryColor, bt.fontWeight600)}><FormattedMessage {...messages.requestAccepted} /></div>
                            <div className={cx(bt.commonSize14, bt.secondaryColor, s.orderStatusContent)}>{content2}</div>
                        </div>
                    </div>
                    <div className={cx(s.orderStatusTrackBox, 'orderStatusTrackBoxRtl', { [s.completedStatus]: progress3 })}>
                        <div className={s.orderStatusTrackImgContainer}><img src={status3} alt="" className={s.orderStatusTrackImg} /></div>
                        <div className={bt.textAlignStart}>
                            <div className={cx(bt.commonSize16, bt.primaryColor, bt.fontWeight600)}><FormattedMessage {...messages.arrived} /></div>
                            <div className={cx(bt.commonSize14, bt.secondaryColor, s.orderStatusContent)}>{content3}</div>
                        </div>
                    </div>
                    <div className={cx(s.orderStatusTrackBox, 'orderStatusTrackBoxRtl', { [s.completedStatus]: progress4 })}>
                        <div className={s.orderStatusTrackImgContainer}><img src={status4} alt="" className={s.orderStatusTrackImg} /></div>
                        <div className={bt.textAlignStart}>
                            <div className={cx(bt.commonSize16, bt.primaryColor, bt.fontWeight600)}><FormattedMessage {...messages.requestReviewed} /></div>
                            <div className={cx(bt.commonSize14, bt.secondaryColor, s.orderStatusContent)}>{content4}</div>
                        </div>
                    </div>
                    <div className={cx(s.orderStatusTrackBox, 'orderStatusTrackBoxRtl', { [s.completedStatus]: progress5 })}>
                        <div className={s.orderStatusTrackImgContainer}><img src={status6} alt="" className={s.orderStatusTrackImg} /></div>
                        <div className={bt.textAlignStart}>
                            <div className={cx(bt.commonSize16, bt.primaryColor, bt.fontWeight600)}><FormattedMessage {...messages.serviceStarted} /></div>
                            <div className={cx(bt.commonSize14, bt.secondaryColor, s.orderStatusContent)}>{content5}</div>
                            {isBookingStarted && <div className={s.orderStatusCancelBookingContainer}>
                                <a href={`/booking/${id}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        history.push({ pathname: `/booking/${id}`, state: { from: history.location.pathname } });
                                    }}
                                    className={bt.viewAllLink}><FormattedMessage {...messages.viewTimeLine} /></a>
                            </div>}
                        </div>
                    </div>
                    <div className={cx(s.orderStatusTrackBox, 'orderStatusTrackBoxRtl', { [s.completedStatus]: progress6 })}>
                        <div className={s.orderStatusTrackImgContainer}><img src={status7} alt="" className={s.orderStatusTrackImg} /></div>
                        <div className={bt.textAlignStart}>
                            <div className={cx(bt.commonSize16, bt.primaryColor, bt.fontWeight600)}><FormattedMessage {...messages.jobCompleted} /></div>
                            <div className={cx(bt.commonSize14, bt.secondaryColor, s.orderStatusContent)}>{content6}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
OrderStatus = reduxForm({
    form: 'OrderStatus',
})(OrderStatus)


export default injectIntl(withStyles(bt, s)(OrderStatus))

